(function (ng) {
    /// <summary>
    /// Service for the evoTrip booking controller to use for interacting with the cart
    /// </summary>
    ng.module('evo.Trip.Services').factory('cartService', ['$http', 'CART_SERVICE_BASE', 'CARTDATA_SERVICE_BASE', function ($http, CART_SERVICE_BASE, CARTDATA_SERVICE_BASE) {
        return {
            book: function (booking) {
                return $http.post(CART_SERVICE_BASE + 'addevotripitems', booking).then(function (response) {
                    return response.data;
                });
            },
            fetchCart: function() {
                return $http.get(CARTDATA_SERVICE_BASE + 'cart').then(function (response) {
                    return response.data;
                });
            }
        };
    }]);
})(angular);